/* eslint-disable camelcase */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { TableChip } from '@ezugi/types';

import { TABLE_BET_LIMITS } from '../../constants/limits';

export type TableBetLimitKey = keyof typeof TABLE_BET_LIMITS;

export type TableLimit = {
  id: number;
  chips: TableChip[];
} & Record<TableBetLimitKey, number>;

export type TableLimits = Record<string, TableLimit>;

type RoundStartTime = {
  time_left: number;
  timestamp: number;
};

type OpenHours = {
  open: null | string;
  close: null | string;
};

export type TableState = {
  id?: number;
  active?: boolean;
  closed_table_image?: string;
  dealer_id?: string;
  dealer_image?: string;
  dealer_name: string;
  game_id?: number;
  history?: any[];
  limits: TableLimits;
  meta_table_id?: number;
  new?: boolean;
  open_hours?: OpenHours;
  open_table_image?: string;
  players_count?: number;
  round_start_time?: RoundStartTime;
  title: string;
  use_dynamic_image?: boolean;
  languages: string[];
  externalTableName?: string; // only oss
  externalTableId?: string; // only oss
}

export const initialState: TableState = {
  limits: {},
  title: 'Default',
  dealer_name: 'Default',
  languages: [],
};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    set(state, { payload }: PayloadAction<Partial<TableState>>) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const tableActions = tableSlice.actions;
export default tableSlice.reducer;
